import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
    position: relative;
    margin-top: 13px;
`;

const Bar = styled.span`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: -2px;

    &:before {
        content: '';
        width: 0;
        height: 2px;

        background-color: rgb(0, 151, 167);
        transition: 0.2s ease all;
    }
`;

const Label = styled.label`
    position: absolute;
    bottom: 50%;
    left: 0;
    transform: translateY(50%);

    font-size: 16px;

    color: inherit;
    opacity: 0.7;

    pointer-events: none;
    transition: 0.2s ease all;
`;

const Input = styled.input`
    display: block;
    padding: 4px 0 6px;

    font-size: 14px;

    color: inherit;
    border: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    background-color: transparent;

    &:focus {
        outline: none;
    }

    &:focus ~ ${Label}, &:not([value='']) ~ ${Label} {
        transform: translateY(-50%);
        font-size: 12px;
        opacity: 0.5;
    }

    &:focus ~ ${Label} {
        color: rgb(0, 151, 167);
        opacity: 1;
    }

    &:focus ~ ${Bar}:before {
        width: 100%;
    }

    ${({ fullWidth }) => fullWidth && 'width: 100%'};
`;

const cb = (action = () => {}) => event => action(event, event.target.value);

const InputMaterial = ({
    value = '',
    floatingLabelText = '',
    fullWidth = false,
    onChange = () => {},
    onBlur = () => {},
}) => (
    <Wrapper>
        <Input type="text" value={value} fullWidth={fullWidth} onChange={cb(onChange)} onBlur={cb(onBlur)} />
        <Bar />
        <Label>{floatingLabelText}</Label>
    </Wrapper>
);

InputMaterial.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    floatingLabelText: PropTypes.string,
    fullWidth: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
};

export default InputMaterial;



/** WEBPACK FOOTER **
 ** ../src/dash/front-v2/components/uiElements/forms/InputMaterial.js
 **/